import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';

export interface OrdersListModel {
  date_purchased;
  orders_id;
  mol_auftrag_id;
}

interface DataStr {
  readyInitBool: any;
  orderInfoDetails: [];
  eanInfo: any;
}
interface ReadyToSendProp {
  data: DataStr;
  apiBase: string;
}

interface ReadyToSendState {
  data: DataStr;
}

export default class ReadyToSend extends React.Component<
  ReadyToSendProp,
  ReadyToSendState
> {
  constructor(props) {
    super(props);
    this.state = { data: this.props.data };
  }
  render(): React.ReactNode {
    let GetEanSearch_local = GetEanSearch(
      '/konto/open',
      this.props.data.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;
    let orderInfoDetails = this.state.data.orderInfoDetails ?? [];

    return (
      <div id="ReadyToSend">
        <div>
          Hier finden Sie die Artikel aus Ihren Bestellungen, die bei uns vor
          Ort und schon versandbereit sind.
          <br />
          <br />
          Unabhängig von Ihrem gewählten Versandtag oder Ihren Versandtagen,
          können Sie den schnellstmöglichen Versand dieser Artikel auslösen, in
          dem Sie auf „Versand veranlassen“ klicken.
          <br />
          <br />
          <br />
          <b>Bitte beachten Sie dabei unsere „Cut-off-Zeit" von 14:00 Uhr.</b>
          <br />
          <br />
        </div>
        <div style={{ float: 'right' }}>
          {this.state.data.readyInitBool ? (
            <>
              <span>
                Ihr Versandwunsch wurde an unsere Logistik &uuml;bermittelt.
                <br />
                Wir versenden Ihre bestellung schnellstm&ouml;glich.
              </span>
            </>
          ) : (
            <a
              style={{
                float: 'right',
                cursor: 'pointer',
                backgroundColor: '#c20f0d',
                color: 'white',
                padding: '5px',
              }}
              onClick={() => {
                let url =
                  this.props.apiBase +
                  '/Account.php?module=readyToSend&sendNow=1';
                fetch(url, {
                  method: 'GET',
                  credentials: 'include',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },
                })
                  .then((res) => res.json())
                  .then(
                    (result) => {
                      this.setState({ data: result.body.readyToSend });
                    },
                    (error) => {},
                  );
              }}
            >
              {' '}
              Versand veranlassen
            </a>
          )}
        </div>

        {GetEanSearch_local_gui}
        <div id="messageContainer"></div>
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
              <th>EAN</th>
              <th>Bezeichnung</th>
              <th>Menge</th>
            </tr>
          </thead>
          <tbody>
            {orderInfoDetails.map((item: any, index) => {
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');

              let link =
                '/konto/mol_orders/' +
                item.mol_auftrag_id +
                '#pos_' +
                item.mol_auftrag_position_id;

              return (
                <tr key={'row_' + item.mol_auftrag_id} className={classNameRow}>
                  <td>{item.date_purchased}</td>
                  <td>
                    <MolLink to={link} href={link}>
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                  <td>{item.bestellreferenz}</td>
                  <td>{item.ean}</td>
                  <td>{item.pos_bezeichnung}</td>
                  <td>{+item.kommisionierung_menge}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
  componentDidMount(): void {
    this.setState({ data: this.props.data });
  }
}
